import classNames from 'classnames';
import type { Dispatch } from 'react';

import { Input, Text } from '@revelio/ui';

import type { TabContentAction } from '../PageConfigProvider/page-reducer';
import type { PositionedItem } from '../PageConfigProvider/types/item';
import panelStyles from './ChartBuilderPanel.module.css';
import { ConfigSection } from './ConfigSection';
import styles from './diverging-bar-combo-settings.module.css';
import labelStyles from './section-label.module.css';

const fieldClassName = classNames(panelStyles.field, panelStyles.compactField);

type DivergingBarComboSettingsProps = {
  item: PositionedItem;
  dispatch: Dispatch<TabContentAction>;
};

export const DivergingBarComboSettings = ({
  item,
  dispatch,
}: DivergingBarComboSettingsProps) => {
  const id = item?.id;
  const combo = item?.plot?.divergingBarCombo;

  return (
    <ConfigSection title="Combo labels">
      <div className={styles.fieldStack}>
        <div>
          <Text
            fontSize="sm"
            weight="semibold"
            className={labelStyles.fieldLabel}
          >
            Comparison Label
          </Text>
          <Input
            size="sm"
            wrapperClassName={fieldClassName}
            placeholder="Comparison"
            value={combo?.comparisonLabel ?? ''}
            onChange={(e) => {
              dispatch({
                type: 'UPDATE_ITEM_DIVERGING_BAR_COMBO',
                payload: {
                  id,
                  divergingBarCombo: {
                    ...combo,
                    comparisonLabel: e.target.value,
                  },
                },
              });
            }}
          />
        </div>
        <div>
          <Text
            fontSize="sm"
            weight="semibold"
            className={labelStyles.fieldLabel}
          >
            Difference Label
          </Text>
          <Input
            size="sm"
            wrapperClassName={fieldClassName}
            placeholder="Difference"
            value={combo?.differenceLabel ?? ''}
            onChange={(e) => {
              dispatch({
                type: 'UPDATE_ITEM_DIVERGING_BAR_COMBO',
                payload: {
                  id,
                  divergingBarCombo: {
                    ...combo,
                    differenceLabel: e.target.value,
                  },
                },
              });
            }}
          />
        </div>
      </div>
    </ConfigSection>
  );
};
